module.exports = __webpack_public_path__ + "static/media/table-design-responsive.8a62b913.svg";